import React from 'react';
import theme from './OptionGroupAccordion.module.scss';
import { OptionGroupLinkStatus, ResidentialUnitExtraData, UnitLinkDto } from '@/types';
import { GroupedResidentialUnits } from '@/utils/residential-units';
import { Badge, BadgeVariant, Tooltip } from '@ygtechnologies/rubus-ui';
import { Trans } from '@lingui/react/macro';

export interface UnitStatusPillsProps {
    group: GroupedResidentialUnits<{
        unit: ResidentialUnitExtraData;
        link: UnitLinkDto;
    }>;
}

type StatusItem = {
    units: { unit: ResidentialUnitExtraData; link: UnitLinkDto }[];
    variant: BadgeVariant;
    label: React.ReactNode;
};

export const UnitStatusPills = ({ group }: UnitStatusPillsProps) => {
    const units = group.units;

    if (units.length === 0) {
        return null;
    }

    const approved = units.filter((x) => x.link.status === OptionGroupLinkStatus.Approved);
    const pending = units.filter((x) => x.link.status === OptionGroupLinkStatus.Pending);
    const rejected = units.filter((x) => x.link.status === OptionGroupLinkStatus.Rejected);

    const items: StatusItem[] = [];
    if (approved.length > 0) {
        items.push({ units: approved, variant: 'success', label: <Trans>Approved: {approved.length}</Trans> });
    }
    if (pending.length > 0) {
        items.push({ units: pending, variant: 'warning', label: <Trans>Pending: {pending.length}</Trans> });
    }
    if (rejected.length > 0) {
        items.push({ units: rejected, variant: 'danger', label: <Trans>Rejected: {rejected.length}</Trans> });
    }

    return (
        <>
            {items.map((item, i) => (
                <Tooltip key={i}>
                    <Tooltip.Trigger>
                        <Badge size="sm" variant={item.variant} appearance="subtle">
                            {item.label}
                        </Badge>
                    </Tooltip.Trigger>
                    <Tooltip.Content style={{ zIndex: 9999 }}>
                        <div className={theme.pillContainer}>
                            {item.units.map((x) => (
                                <Badge key={x.unit.id} size="sm" variant={item.variant} appearance="subtle">
                                    {x.unit.name}
                                </Badge>
                            ))}
                        </div>
                    </Tooltip.Content>
                </Tooltip>
            ))}
        </>
    );
};
